export const TAG_POINTSMALL = 'pointsmall';
export const TAG_BONUS = 'bonus';
export const TAG_XMASSALE = 'xmassale';
export const TAG_SUPERFLASHSALE = 'superflashsale';
export const TAG_WHOLESALE = 'wholesale';
export const TAG_FLASHSALE = 'flashsale';
export const TAG_BESTSELLER = 'bestseller';
export const TAG_NEWARRIVAL = 'newarrival';
export const TAG_PRESALE = 'presale';